const namespace = 'bravissimo/communication-prefs/';

export const UPDATE_COMMUNICATION_PREFS_REQUEST = `${namespace}UPDATE_COMMUNICATION_PREFS_REQUEST`;
export const UPDATE_COMMUNICATION_PREFS_FAILURE = `${namespace}UPDATE_COMMUNICATION_PREFS_FAILURE`;
export const UPDATE_COMMUNICATION_PREFS_SUCCESS = `${namespace}UPDATE_COMMUNICATION_PREFS_SUCCESS`;
export const COMMUNICATION_PREFS_CLOSE_MESSAGES = `${namespace}COMMUNICATION_PREFS_CLOSE_MESSAGES`;
